import { PROBIODELIGHTS_CUSTOMER_LAUNCH_ENABLED } from "../config/featureFlags";

export const getDisplayPrice = (product = {}, selectedOption = null) => {
  if (selectedOption?.price != null) {
    return Number(selectedOption.price) || 0;
  }

  const options = Array.isArray(product?.options) ? product.options : [];

  if (options.length) {
    const firstOption = options[0];
    if (firstOption?.price != null) {
      return Number(firstOption.price) || 0;
    }
  }

  return Number(product?.price) || 0;
};

export const getRelatedProducts = (products = [], currentProduct = {}) => {
  const currentCategory = String(currentProduct?.category || "").trim().toLowerCase();
  const currentBusinessLine = String(currentProduct?.business_line || "").trim().toLowerCase();

  if (!currentCategory) {
    return [];
  }

  const sameCategory = products
    .filter((product) => {
      const productCategory = String(product?.category || "").trim().toLowerCase();
      return (
        product?.slug !== currentProduct?.slug &&
        productCategory === currentCategory &&
        Boolean(product?.slug)
      );
    })
    .slice(0, 4);

  if (!PROBIODELIGHTS_CUSTOMER_LAUNCH_ENABLED || !currentBusinessLine) return sameCategory;

  return [
    ...sameCategory.filter((product) => String(product?.business_line || "").trim().toLowerCase() === currentBusinessLine),
    ...sameCategory.filter((product) => String(product?.business_line || "").trim().toLowerCase() !== currentBusinessLine),
  ].slice(0, 4);
};
